import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('the Auteur Cloud root element is missing');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
